import { DisplayCallingPoint } from '@gomedia-apis-ts-pis/v1'

export const isNoJourneyAvailable = (
  callingPoints: DisplayCallingPoint[],
): boolean => {
  return !callingPoints || !callingPoints.length
}
